import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterIssueStatusHistory } from '@/api/model/interfaces';

export default class RegisterIssueStatusHistoryOdata extends OdataManager<RegisterIssueStatusHistory> {}
